import "./loading.scss";
import * as React from "react";

type Props = {
    children?: React.ReactNode;
};

export default class LoadingScreen extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <div className="loading-screen" data-testid="loading-screen">
                <div className="loading-spinner">
                    <div className="loading-spinner-1" />
                    <div className="loading-spinner-2" />
                </div>
                <div className="loading-message">
                    {this.props.children}
                </div>
            </div>
        );
    }
}
